import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import AWSSecurityHubCredentialsForm from "./AWSSecurityHubCredentialsForm";
import AWSSecurityHubConfigListing from "./AWSSecurityHubConfigListing";

export default function AWSSecurityHUbPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={AWSSecurityHubCredentialsForm}
      PullConfigListingView={AWSSecurityHubConfigListing}
    />
  );
}
